module.exports = __webpack_public_path__ + "img/orgIcon.9ce659cf.svg";